export const weatherAppAPI = "d115fb6b56b3e7bb6faf4367e0ba0e37";

export const googleMapAPI = "AIzaSyAq15HbfCRMW7RqNb5LUNyOLyfzpYI0wl4";
